<template>
  <b-card>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <b-button class="m-1" variant="primarySpore" @click="back()">{{$t('Labels.Back')}}</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="float-right" cols="12" md="12">
        <feather-icon v-b-tooltip.hover.left title="Editar" icon="EditIcon" @click="edit = true" class="float-right cursor-pointer" svgClasses="hover:text-primary" v-if="!edit" />
      </b-col>
    </b-row>

    <div v-if="!edit">
      <b-row class="m-2">
        <b-col v-if="response.cfeZone" cols="12" md="4" class="p-1">
          <h4>Zona: </h4> {{ response.cfeZone ? response.cfeZone.name : '' }}
        </b-col>
         <b-col v-if="response.cfeTeam" cols="12" md="4" class="p-1">
          <h4>Cuadrilla: </h4> {{ response.cfeTeam ? response.cfeTeam.name : '' }}
        </b-col>
        <b-col cols="12" md="4" class="p-1">
          <h4>Número: </h4> {{response.number}}
        </b-col>
        <b-col cols="12" md="4" class="p-1">
          <h4>Proyecto: </h4> {{response.name}}
        </b-col>
      </b-row>
    </div>

    <b-form class="m-2" v-if="show">
      <b-row v-if="edit === true">
        <b-col  cols="12" md="4">
          <b-form-group label="Zona *" label-for="cfeZone" >
            <v-select  input-id="cfeZone" :options="listZones" :clearable="false" v-model="selectedZone"
            placeholder="Seleccionar Zona"/>
          </b-form-group>
        </b-col>
        <b-col  cols="12" md="4">
          <b-form-group label="Cuadrilla *" label-for="cfeTeam" >
            <v-select disabled input-id="cfeTeam" :options="listTeams" :clearable="false" v-model="selectedTeam" v-if="listTeams"
            placeholder="Seleccionar Cuadrilla"/>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group label="Número *" label-for="number">
            <b-form-input id="number" v-model="response.number" trim></b-form-input>
            </b-form-group>
        </b-col>
         <b-col cols="12" md="4">
          <b-form-group label="Proyecto *" label-for="name">
            <b-form-input id="name" v-model="response.name" trim></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>

    <!-- Action Buttons -->
    <div v-if="edit">
      <b-button type="submit" class="m-1" variant="primarySpore" @click="save()">{{$t('Labels.Save')}}</b-button>
      <b-button type="reset" class="m-1" variant="outline-danger" @click="cancel()">{{$t('Labels.Cancel')}}</b-button>
    </div>

  </b-card>

</template>

<script>
/* eslint-disable global-require */

import {
  BButton, BCard, BForm, BCol, BRow, BFormGroup, BFormInput, VBTooltip
} from 'bootstrap-vue'

import request from '@/libs/request/index'
import { app } from '@/main'
import { empty } from '@/libs/tools/helpers'
import vSelect from 'vue-select'
import store from '@/store'

const divisionUuid = store.state.session.AppActiveUser().division.uuid

export default {
  components: {
    BButton, BCard, BForm, BCol, BRow, BFormGroup, vSelect, BFormInput
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  data () {
    return {
      edit: false,
      uuid: this.$route.params.uuid,
      listZones: [{ title: '', value: '', label: '' }],
      listTeams: [{ title: '', value: '', label: '' }],
      response: {},
      selectedZone: {},
      selectedTeam: {},
      show: true
    }
  },
  methods: {
    cancel () {
      this.edit = false
      this.getDetail()
    },
    back () {
      app.$router.push('/projects')
    },
    validateEmpty () {
      if (empty(this.response.name) || empty(this.response.number) || empty(this.selectedTeam.value) || empty(this.selectedZone.value)) {
        this.$swal({
          title: this.$t('Messages.Fail'),
          text: this.$t('Messages.MissingParams'),
          icon: 'error'
        })
        return true
      }
    },
    async getDetail () {
      const params = {
        url: `/projects/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          this.response = data.data.data[0]

          if (this.response.cfeZone != null) {
            this.selectedZone = {
              title: this.response.cfeZone.name,
              value: this.response.cfeZone.uuid,
              label: this.response.cfeZone.name
            }
          }

          if (this.response.cfeTeam != null) {
            this.selectedTeam = {
              title: this.response.cfeTeam.name,
              value: this.response.cfeTeam.uuid,
              label: this.response.cfeTeam.name
            }
          }
        }
      })
    },
    async getZones () {
      const params = {
        url: '/zones',
        method: 'GET',
        params: { divisionUuid }
      }
      await request(params).then(data => {
        if (data.status === 200) {
          for (const item of data.data) {
            this.listZones.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    async getTeams () {
      const params = {
        url: '/teams/list/all',
        method: 'GET'
      }
      await request(params).then(data => {
        if (data.data.code === 200) {
          for (const item of data.data.data) {
            this.listTeams.push({
              title: item.name,
              value: item.uuid,
              label: item.name
            })
          }
        }
      })
    },
    async save () {
      if (!this.validateEmpty()) {
        const params = {
          url: `/projects/${this.uuid}`,
          method: 'PUT',
          params: {
            zoneUuid: this.selectedZone.value,
            teamUuid: this.selectedTeam.value,
            name: this.response.name,
            number: this.response.number
          }
        }
        await request(params).then(data => {
          this.edit = false
          this.getDetail()
        }).catch(err => {
          const errMsg = err?.response?.data?.error || err?.response?.data?.msg
          if (errMsg) {
            this.$swal({
              title: 'Error',
              text: errMsg,
              timer: 5000,
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-warning'
              },
              buttonsStyling: false
            })
          }
        })
      }
    }
  },
  created () {
    this.getZones()
    this.getTeams()
    this.getDetail()
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
